import React from "react";
import { Field, reduxForm } from "redux-form";

const SurveyForm = props => {
  const { handleSubmit, pristine, reset, submitting, initialize } = props;
  return (
    <form onSubmit={handleSubmit}>
      <div>
        <label>Version</label>
        <div>
          <Field style={{width: 500}} name="version" component="input" type="text" />
        </div>
      </div>
      <div>
        <label>Message</label>
        <div>
          <Field style={{width: 500}} name="message" component="input" type="text" />
        </div>
      </div>
      <div>
        <label>Link</label>
        <div>
          <Field style={{width: 500}} name="link" component="input" type="text" />
        </div>
      </div>
      <div style={{marginTop: 12}}>
        <button
          style={{
            marginRight: 8,
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 12,
            paddingRight: 12,
            backgroundColor: "rgba(38, 194, 129, 1)",
            borderRadius: 4,
            color: "white",
            fontSize: 14
          }}
          type="submit"
          disabled={submitting}
        >
          Submit
        </button>
        <button
          style={{
            marginRight: 8,
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 12,
            paddingRight: 12,
            backgroundColor: "rgba(38, 194, 129, 1)",
            borderRadius: 4,
            color: "white",
            fontSize: 14
          }}
          type="button"
          disabled={submitting}
          onClick={() => initialize({
            version: null,
            message: null,
            link: null,
          })}
        >
          Clear Values
        </button>
      </div>
    </form>
  );
};

export default reduxForm({
  form: "blitzsurvey", // a unique identifier for this form
  enableReinitialize: true,
})(SurveyForm);



// WEBPACK FOOTER //
// ./src/cms/alert/SurveyForm.js